export const actionTypes = {
  SHOW_LIMITED_FEATURES_DIALOG: 'SHOW_LIMITED_FEATURES_DIALOG',
  HIDE_LIMITED_FEATURES_DIALOG: 'HIDE_LIMITED_FEATURES_DIALOG',
};

const showLimitedFeaturesDialog = ({
  description,
  onUpgrade,
  img,
  classNameImg,
  maxWidth,
  showButtonUnderstand,
}) => ({
  type: actionTypes.SHOW_LIMITED_FEATURES_DIALOG,
  payload: {
    description,
    onUpgrade,
    img,
    classNameImg,
    maxWidth,
    showButtonUnderstand,
  },
});

const hideLimitedFeaturesDialog = () => ({
  type: actionTypes.HIDE_LIMITED_FEATURES_DIALOG,
});

export { showLimitedFeaturesDialog, hideLimitedFeaturesDialog };
